import { DateTime } from 'luxon';
import { sigla } from '../../../shared/utils/formatters/sigla.formatter';
import { useValidarAlocacaoLazyQuery } from '../../graphql/queries/validar_alocacao.query';
import { ValidarAlocacaoQuery } from '../../graphql/queries/__generated__/ValidarAlocacaoQuery';
import { IProfessorAlocacoes } from '../../reducers/alocacao.reducer';

const validar_alocacao = (selecao: IProfessorAlocacoes) => {
  const somente_turmas_vazias =
    selecao.alocacoes.length > 0 && selecao.alocacoes.every(({ alocacao }) => !alocacao.professor);

  const somente_planejamentos =
    selecao.alocacoes.length > 0 &&
    selecao.alocacoes.every(({ alocacao }) => alocacao.planejamento);

  return Boolean(
    (selecao.professor && selecao.disciplina && selecao.horario && somente_turmas_vazias) ||
      somente_planejamentos
  );
};

const validar_planejamento = (selecao: IProfessorAlocacoes) => {
  const somente_turmas_vazias =
    selecao.alocacoes.every(({ alocacao }) => !alocacao.professor) &&
    Boolean(selecao.alocacoes.length);

  return Boolean(
    selecao.professor && selecao.disciplina && selecao.horario && somente_turmas_vazias
  );
};

const validar_desalocacao = (selecao: IProfessorAlocacoes) => {
  const somente_professores =
    selecao.alocacoes.every(({ alocacao }) => alocacao.professor) &&
    Boolean(selecao.alocacoes.length);

  return somente_professores;
};

const validar_alocacoes = async (
  selecao: IProfessorAlocacoes,
  alocacao_cache: ValidarAlocacaoQuery | undefined,
  obter_alocacao: (data: any) => any,
  refetch_obter_alocacao: (data: any) => any
) => {
  if (!selecao.professor || !selecao.disciplina || !selecao.horario) return;

  const mensagens = new Array<string>();

  for (const selec_alocacao of selecao.alocacoes) {
    if (selec_alocacao.alocacao.professor) {
      continue;
    }

    const { data } = alocacao_cache
      ? await refetch_obter_alocacao({
          id_professor: selecao.professor.id_professor,
          id_horario: selecao.horario.id_horario,
          dat_alocacao: selec_alocacao.alocacao.dat_alocacao,
        })
      : await obter_alocacao({
          variables: {
            id_professor: selecao.professor.id_professor,
            id_horario: selecao.horario.id_horario,
            dat_alocacao: selec_alocacao.alocacao.dat_alocacao,
          },
        });

    const data_formatada = DateTime.fromISO(selec_alocacao.alocacao.dat_alocacao, {
      setZone: true,
    }).toFormat('dd/MM/yyyy');

    if (data?.validar_alocacoes_professores.length) {
      for (const alocacao of data.validar_alocacoes_professores) {
        mensagens.push(
          `Já existe alocação/planejamento na grade ${sigla(
            alocacao.oferta.curso?.dsc_nome_curso,
            alocacao.oferta.curso?.dsc_sigla_curso
          )} ${alocacao.oferta.num_oferta}.${alocacao.turma.num_turma} para a disciplina ${
            alocacao.disciplina.dsc_sigla
          } - ${data_formatada}`
        );
      }
    }
  }

  if (mensagens.length) {
    return mensagens.join('\n');
  }
};

export { validar_alocacao, validar_planejamento, validar_desalocacao, validar_alocacoes };
